import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-staff-group',
  templateUrl: './staff-group.component.html',
  styleUrls: ['./staff-group.component.css']
})
export class StaffGroupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
